<template>
    <div>
        <div class="attribute-sample-images-grid">
            <div v-for="(image, index) in images" :key="image.id"
                 class="attribute-sample-image-item"
                 @click="openModal(index)">
                <webp-picture v-if="image.webp_path" :webp="image.webp_path" class="inherit">
                    <img :src="image.img_file" :alt="`${talentName} ${attributeName}`" loading="lazy" class="attribute-sample-image clickable">
                </webp-picture>
                <img v-else :src="image.img_file" :alt="`${talentName} ${attributeName}`" loading="lazy" class="attribute-sample-image clickable">
            </div>
        </div>

        <!-- モーダル -->
        <sample-image-modal
            :show="showModal"
            :image-data="currentImageData"
            :show-talent-button="showTalentButton"
            @close="closeModal"
        ></sample-image-modal>
    </div>
</template>

<script>
export default {
    props: {
        images: {
            type: Array,
            required: true
        },
        imagesWithDetail: {
            type: Array,
            required: true
        },
        showTalentButton: {
            type: Boolean,
            default: true
        },
        talentName: {
            type: String,
            default: ''
        },
        attributeName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            showModal: false,
            currentImageData: {}
        };
    },
    methods: {
        openModal(index) {
            if (this.imagesWithDetail[index]) {
                this.currentImageData = this.imagesWithDetail[index];
                this.showModal = true;
                // GAイベント送信
                this.sendImageClickToGa(this.imagesWithDetail[index]);
            }
        },

        /**
         * 画像クリックイベントをGoogle Analyticsに送信
         * @param {Object} imageData - 画像データ
         */
        sendImageClickToGa(imageData) {
            // モデル詳細ページ用
            let pageName = 'モデル詳細';
            // 検索キーワードを取得
            const urlParams = new URLSearchParams(window.location.search);
            const keyword = urlParams.get('keyword') || '';
            // GA送信用のデータを構築
            const imageModel = imageData.talents && imageData.talents.length > 0
                ? imageData.talents.join(',')
                : '';
            const imageItem = imageData.item_title || '';
            const imageURL = imageData.img_file || '';
            if (typeof gtag !== 'undefined') {
                gtag('event', 'imageClick', {
                    'imageModel': imageModel,
                    'imageItem': imageItem,
                    'imageURL': imageURL,
                    'inputKeyword': keyword,
                    'pageName': pageName,
                });
            }
        },
        closeModal() {
            this.showModal = false;
        }
    }
};
</script>

<style scoped>
.attribute-sample-images-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}

.attribute-sample-image-item {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 141.4%; /* A4比率 */
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 4px;
    cursor: pointer;
}

.attribute-sample-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.attribute-sample-image.clickable {
    transition: opacity 0.2s;
}

.attribute-sample-image-item:hover .attribute-sample-image.clickable {
    opacity: 0.8;
}

@media (max-width: 767px) {
    .attribute-sample-images-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
        margin-bottom: 16px;
    }
}
</style>
